(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "lodash/isNil", "lodash/isArray"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("lodash/isNil"), require("lodash/isArray"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.isNil, global.isArray);
    global.ensureArrayValue = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _isNil, _isArray) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  _exports.__esModule = true;
  _exports["default"] = wrapInArray;
  _isNil = _interopRequireDefault(_isNil);
  _isArray = _interopRequireDefault(_isArray);

  function wrapInArray(v) {
    return !(0, _isNil["default"])(v) ? (0, _isArray["default"])(v) ? v : [v] : [];
  }
});
//# sourceMappingURL=ensureArrayValue.js.map